export const onMessageReceive = (event: MessageEvent, id: string) => {
  const iframe = document.getElementById(id) as HTMLIFrameElement | null;

  // Ensure event.data is an object before checking properties
  if (
    iframe &&
    event.data &&
    typeof event.data === 'object' &&
    'height' in event.data
  ) {
    const { height } = event.data as any;
    iframe.style.height = `${height}px`;
  }
};

const setIframeHeight = (iframe: HTMLIFrameElement) => {
  if (iframe?.contentWindow) {
    iframe.contentWindow.postMessage('height', '*');
  }
};

export const queryForHeight = (id: string) => {
  let resizeTimeout: ReturnType<typeof setTimeout> | undefined;

  clearTimeout(resizeTimeout);

  resizeTimeout = setTimeout(() => {
    const iframe = document.getElementById(id) as HTMLIFrameElement | null;
    if (iframe) {
      setIframeHeight(iframe);
    }
  }, 50);
};

const getUtmParams = () => {
  const searchParams = new URLSearchParams(window.location.search);
  const allowedUtmAttributes = ['utm_source', 'utm_medium'];

  return allowedUtmAttributes.reduce((acc, param) => {
    const value = searchParams.get(param);

    return {
      ...acc,
      ...(value && { [param]: value }),
    };
  }, {});
};

export const postUtmParamsToIframe = (id: string) => {
  const iframe = document.getElementById(id) as HTMLIFrameElement | null;

  if (!iframe) return;

  const utmParams = getUtmParams();

  // Prevent runtime crash: contentWindow can be null if iframe not loaded yet
  if (iframe.contentWindow) {
    iframe.contentWindow.postMessage(
      {
        type: 'utm',
        data: utmParams,
      },
      '*'
    );
  } else {
    console.warn(
      `[postUtmParamsToIframe] iframe #${id} not ready (contentWindow null)`
    );
  }
};
